module.exports = __webpack_public_path__ + "static/img/13.e739132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/13.jpg
// module id = 3oHP
// module chunks = 0